import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { Seo } from '../components/seo/Seo';

export default function NotFoundPage() {
  const { user } = useAuthStore();

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-4">
      <Seo
        title="Page Not Found | Hustli"
        description="The page you're looking for doesn't exist or may have moved."
        noIndex
      />
      <div className="text-center max-w-md">
        <p className="text-primary font-bold text-sm tracking-wide uppercase mb-2">404</p>
        <h1 className="text-3xl font-bold text-dark mb-3">Page not found</h1>
        <p className="text-stone-600 mb-8">
          The page you're looking for doesn't exist or may have moved.
        </p>
        <Link
          to={user ? '/dashboard' : '/'}
          className="btn-primary inline-flex items-center justify-center px-6 py-3"
        >
          {user ? 'Back to Dashboard' : 'Back to Home'}
        </Link>
      </div>
    </div>
  );
}
